import { createSlice } from "@reduxjs/toolkit";
import cloneDeep from "lodash/cloneDeep";
import { routerChangeAction } from "const";

const modalState = {
  loading: false,
  error: false,
  messageId: undefined,
  code: undefined,
  actions: {},
  state: {},
};

const initialState = {
  ...cloneDeep(modalState),
  subModal: cloneDeep(modalState),
};

const slice = createSlice({
  initialState,
  name: "centralModals",
  reducers: {
    setModalLoading: (state, action) => {
      state.loading = action.payload;
    },
    openModal: (state, { payload = {} }) => {
      return { ...state, ...initialState, ...payload };
    },
    openErrorModal: (state, { payload = {} }) => {
      return { ...state, ...initialState, ...payload, error: true };
    },
    closeModal: () => initialState,
    openSubModal: (state, { payload = {} }) => {
      state.subModal = { ...state, ...modalState, ...payload, error: true };
    },
    closeSubModal: (state) => {
      state.subModal = cloneDeep(modalState);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(routerChangeAction, () => initialState);
  },
});

export const { setModalLoading, openModal, openErrorModal, closeModal, openSubModal, closeSubModal } = slice.actions;

export default slice;
